import React from 'react';
import { Section, TextInput, Textarea } from './ui';

export default function BasicSection({ form, set, errors }) {
  return (
    <Section title="Identidad">
      <div className="grid grid-cols-2 gap-x-6 gap-y-5">
        <div className="col-span-2">
          <TextInput label="Nombre *" value={form.name} onChange={e => set('name', e.target.value)}
            placeholder="HP Victus 15…" error={errors.name} />
        </div>
        <TextInput label="Marca" value={form.brand} onChange={e => set('brand', e.target.value)} placeholder="HP, Asus…" />
        <TextInput label="Categoría" value={form.category} onChange={e => set('category', e.target.value)} placeholder="Laptop, Monitor…" />
        <TextInput label="Tipo" value={form.type} onChange={e => set('type', e.target.value)} placeholder="gaming, office, creator…" />
        <div className="col-span-2">
          <TextInput label="URL Proveedor" value={form.supplier_url} onChange={e => set('supplier_url', e.target.value)} placeholder="https://…" />
        </div>
        <div className="col-span-2">
          <Textarea label="Descripción" rows={4} value={form.description}
            onChange={e => set('description', e.target.value)} placeholder="Descripción…" />
        </div>
      </div>
    </Section>
  );
}
